import * as React from 'react';
import { FC } from 'react';
import { JackpotAggregatorCampaignViewProps } from './types';

const Rules: FC<JackpotAggregatorCampaignViewProps> = (props) => (
  <div className="j-w_how jw-how" aria-labelledby="how-to-win">
    <div className="jw-how_wrapper">
      <h2 className="jw-how_title" id="how-to-win">
        {props.locales.how_to_win}
      </h2>
      <ul className="jw-how_list">
        <li className="jw-how_item">
          <div className="jw-how_number">
            <span>1</span>
          </div>
          <div className="jw-how_text">
            <p>{props.locales.choose_game}</p>
          </div>
          <div className="jw-how_image jw-how_image__bandit">
            <img src="/images/jackpot/bandit.png" alt="" />
          </div>
        </li>
        <li className="jw-how_item">
          <div className="jw-how_number">
            <span>2</span>
          </div>
          <div className="jw-how_text">
            <p>{props.locales.make_bets}</p>
          </div>
          <div className="jw-how_image jw-how_image__coins">
            <img src="/images/jackpot/coins.png" alt="" />
          </div>
        </li>
        <li className="jw-how_item">
          <div className="jw-how_number">
            <span>3</span>
          </div>
          <div className="jw-how_text">
            <p>{props.locales.play_and_win}</p>
          </div>
          <div className="jw-how_image jw-how_image__money">
            <img src="/images/jackpot/money.png" alt="" />
          </div>
        </li>
      </ul>
      <div className="jw-how_links">
        <a href="/casino/search?badge=jackpot">{props.locales.play}</a>
      </div>
    </div>
  </div>
);
export default Rules;
